import { render, staticRenderFns } from "./SpinLuckRuleConfig.vue?vue&type=template&id=7207b64e&scoped=true"
import script from "./SpinLuckRuleConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./SpinLuckRuleConfig.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SpinLuckRuleConfig.vue?vue&type=style&index=0&id=7207b64e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.16_babel-core@7.0.0-bridge.0_@babel+core@7.27._f767d633ff263e3cf51932694db5e4d0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7207b64e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/front/game-platform-web/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7207b64e')) {
      api.createRecord('7207b64e', component.options)
    } else {
      api.reload('7207b64e', component.options)
    }
    module.hot.accept("./SpinLuckRuleConfig.vue?vue&type=template&id=7207b64e&scoped=true", function () {
      api.rerender('7207b64e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/admin/operation/components/SpinLuckRuleConfig.vue"
export default component.exports